<template>
    <div class="menu-content">
        <div class="rel menu-content-dialog">
            <div
                v-if="isActiveAction"
                class="abs menu-content-elements"
                :style="{ left: left + 'px', top: y + 'px', height: height + 'px', width: width + 'px' }"
            >
                <slot></slot>
            </div>
        </div>
        <div class="menu-content-icon-text" :style="{ color: color, 'background-color': backgroundColorActive }" @click="activeItem">
            <i class="menu-icon" :class="icon" :style="{ 'font-size': size + 'px' }"></i>
            <div class="menu-content-text" v-if="text !== null">{{ text.toUpperCase() }}</div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Globals from "../../globals";

export default {
    props: {
        id: { type: String, default: () => Globals.UUID() },
        icon: { type: String },
        text: { type: String, default: null },
        size: { type: Number, default: 16 },
        color: { type: String, default: "#FFFFFF" },
        active: { type: Boolean, default: false },
        width: { type: Number },
        image: { type: String },
        action: { type: Function, default: null }
    },

    data() {
        return {
            x: 0,
            y: 0,
            height: 0,
            isActiveAction: false
        };
    },
    watch: {
        onChange(value) {
            let idMenu = this.$parent.id;
            let id = this.id;
            this.isActiveAction = this.isActive(idMenu, id);
        }
    },
    computed: {
        ...mapGetters("gui/menubar", {
            isActive: "isActive",
            onChange: "onChange"
        }),

        left() {
            return -this.width - 10;
        },

        backgroundColorActive() {
            let color = this.$parent.backgroundColor;
            if (this.isActiveAction) {
                color = this.$parent.backgroundColorActive;
            }

            return color;
        }
    },
    created() {
        if (this.active) {
            this.activeItem();
        }
    },
    mounted() {
        let elt = this.$parent.$el;
        if (elt) {
            let rect = elt.getBoundingClientRect();
            let eltMenuItem = this.$el;
            let rect2 = eltMenuItem.getBoundingClientRect();
            let height = rect.height;
            this.height = height - 100;
            this.y = rect.y - rect2.y;
        }
    },
    methods: {
        ...mapActions("gui/menubar", {
            addMenuItemActive: "addMenuItemActive"
        }),

        activeItem() {
            let idMenu = this.$parent.id;
            // console.log(HTMLUtils.hexToRgbA(this.$parent))
            let id = this.id;
            this.addMenuItemActive({ idMenu, id });
            this.isActiveAction = this.isActive(idMenu, id);
            if (this.action !== null) {
                // console.log(this.action, '======================')
                this.action.call();
                this.addMenuItemActive({ idMenu, id });
                this.isActiveAction = this.isActive(idMenu, id);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.menu-content {
    padding: 10px;
    .menu-content-elements {
        background-color: #f4f4f4;
    }
    .menu-content-icon-text {
        padding: 2px;
        border-radius: 5px;
        margin: 0px;
        text-align: center;
        .menu-icon {
            padding: 5px;
        }

        .menu-content-text {
            font-size: 10px;
        }
    }

    .menu-content-icon-text-active {
        background-color: #878787;
        /*opacity: 0.8;*/
    }

    .menu-content-icon-text:hover {
        background-color: #6f6f6f;
    }
}
</style>



// WEBPACK FOOTER //
// MenuItem.vue?32f2593f